module.exports = __webpack_public_path__ + "static/media/ic_zh-cn.f3a1522b.svg";